/* eslint-disable no-unused-vars */

import React from "react";
import {
  Animated,
  Button as RNButton,
  Platform,
  ProgressBar,
  ProgressBarAndroid,
  ProgressViewIOS,
  Text,
  View,
} from "react-native";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MenuButton from "../components/MenuButton";
import { errorColors, RepositColours, RepositStyles } from "../utils/styles";
import storage from "../utils/storage";
import goTo from "../utils/goTo";
import { checkHighstate, startHighstate } from "../redux/actions/highstate";
import { insertSerialNum } from "../redux/actions/box";
import Phone from "../utils/Phone";
import WebHeading from "../components/WebHeading";

import Icon from "react-native-vector-icons/FontAwesome";

const timeCircle = (
  <Icon name="exclamation-circle" size={100} color={errorColors.red} />
);

const mapStateToProps = (state) => ({
  box: state.box,
  highstate: state.highstate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    highstateActions: bindActionCreators(
      { startHighstate, checkHighstate, insertSerialNum },
      dispatch
    ),
  };
};

class SoftwareInstallation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      message: "Starting software installation",
      fade: new Animated.Value(0),
    };
  }

  progressCreep = () => {
    if (
      this.state.progress < 0.92 &&
      this.props.highstate.status !== "FAILED" &&
      this.props.highstate.status !== "SUCCEEDED"
    ) {
      this.setState({ progress: this.state.progress + 0.01 });
      setTimeout(this.progressCreep, 6000);
    }
  };

  componentDidMount = () => {
    let serialNum = this.props.box.serialNumber;
    if (!serialNum) {
      storage
        .load({ key: "serialNum" })
        .then((ret) => {
          this.props.highstateActions.insertSerialNum(ret);
          this.props.highstateActions.startHighstate(ret);
        })
        .catch((err) => {
          console.log(err);
          this.props.highstateActions.startHighstate(
            this.props.box.serialNumber
          );
        });
    } else {
      this.props.highstateActions.startHighstate(this.props.box.serialNumber);
    }

    setTimeout(this.highstateCheck, 30000);
    this.progressCreep();
    setTimeout(this.breatheIn, 3000);
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.highstate.message !== null &&
      nextProps.highstate.message !== null
    ) {
      if (
        !this.props.highstate.message.includes("Restarting reposit") &&
        nextProps.highstate.message.includes("Restarting reposit")
      ) {
        this.setState({ progress: 0.68 });
      }
    }

    if (
      this.props.highstate.status !== "SUCCEEDED" &&
      nextProps.highstate.status === "SUCCEEDED"
    ) {
      goTo(this.props.navigation, "Revalidate");
    }
  }

  restartHighState = () => {
    this.setState({
      progress: 0,
      message: "Starting software installation",
      fade: new Animated.Value(0),
    });
    this.props.highstateActions.startHighstate(this.props.box.serialNumber);
    setTimeout(this.highstateCheck, 30000);
    this.progressCreep();
    setTimeout(this.breatheIn, 3000);
  };

  breatheIn = () => {
    Animated.timing(this.state.fade, {
      toValue: 1,
      duration: 2000,
    }).start();
    if (
      this.props.highstate.status !== "FAILED" &&
      this.props.highstate.status !== "SUCCEEDED"
    ) {
      setTimeout(this.breatheOut, 2500);
    }
  };

  breatheOut = () => {
    Animated.timing(this.state.fade, {
      toValue: 0,
      duration: 2000,
    }).start();
    setTimeout(this.breatheIn, 5000);
  };

  highstateCheck = () => {
    const hs = this.props.highstate;
    if (
      hs.init &&
      !hs.fetching &&
      hs.status !== "FAILED" &&
      hs.jid &&
      hs.status !== "SUCCEEDED"
    ) {
      this.props.highstateActions.checkHighstate(
        this.props.box.serialNumber,
        hs.jid
      );
      setTimeout(this.highstateCheck, 20000);
    } else if (
      hs.init &&
      hs.status !== "FAILED" &&
      hs.jid &&
      hs.status !== "SUCCEEDED"
    ) {
      setTimeout(this.highstateCheck, 20000);
    }
  };
  static navigationOptions = {
    title: "Software Installation",
    headerRight: <MenuButton />,
  };

  render() {
    const hs = this.props.highstate;
    let navigate;
    if (Platform.OS !== "web") {
      navigate = this.props.navigation.navigate;
    } else {
      navigate = null;
    }
    return (
      <View style={RepositStyles.wrapper}>
        <WebHeading title="Software Installation" />
        <View
          style={{
            flex: 1,
            backgroundColor: hs.status === "FAILED" ? "white" : "#3CA5D5",
          }}
        >
          <View
            style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
          >
            {hs.status === "FAILED" ? (
              <View>
                <Text>{timeCircle}</Text>
              </View>
            ) : (
              <Animated.Image
                style={{ width: 150, height: 150, opacity: this.state.fade }}
                resizeMode="contain"
                source={require("../img/reposit_mark_white.png")}
              />
            )}
          </View>
          {hs.status === "FAILED" ? (
            <View
              style={{
                flex: 1,
                marginHorizontal: 40,
                justifyContent: "flex-start",
              }}
            >
              <Text
                style={{
                  ...RepositStyles.headerText,
                  marginTop: 30,
                  marginBottom: 10,
                  color: errorColors.red,
                  textAlign: "center",
                }}
              >
                Software Installation Failed
              </Text>
              <Text
                style={{
                  ...RepositStyles.paragraphText,
                  color: RepositColours.blue,
                  marginTop: 10,
                  marginBottom: 20,
                  textAlign: "center",
                }}
              >
                <Phone>Call Reposit on</Phone>
              </Text>
              <RNButton
                title="Retry"
                color={RepositColours.blue}
                onPress={() => this.restartHighState()}
              />
            </View>
          ) : (
            <View
              style={{
                flex: 1,
                marginHorizontal: 30,
                justifyContent: "flex-start",
              }}
            >
              {Platform.OS === "ios" ? (
                <ProgressViewIOS
                  progress={this.state.progress}
                  progressTintColor="white"
                  trackTintColor="#286A93"
                  progressViewStyle="bar"
                />
              ) : Platform.OS === "android" ? (
                <ProgressBarAndroid
                  progress={this.state.progress}
                  styleAttr="Horizontal"
                  indeterminate={false}
                  color="white"
                />
              ) : (
                <ProgressBar
                  progress={this.state.progress}
                  indeterminate={false}
                  color="white"
                  trackColor="#286A93"
                />
              )}
              <Text
                style={{
                  ...RepositStyles.headerText,
                  marginTop: 30,
                  marginBottom: 10,
                  color: "white",
                  textAlign: "center",
                }}
              >
                {hs.message}
              </Text>
              <Text
                style={{
                  ...RepositStyles.paragraphText,
                  textAlign: "center",
                  color: "#B1E2F3",
                  marginTop: 10,
                }}
              >
                ETA {Math.round(14 - 14 * this.state.progress)} minutes
              </Text>
            </View>
          )}
        </View>
      </View>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SoftwareInstallation);



// WEBPACK FOOTER //
// ./src/containers/SoftwareInstallation.js